import { ApolloClient, HttpLink, InMemoryCache, NormalizedCacheObject } from '@apollo/client';

let client: ApolloClient<NormalizedCacheObject> | null = null;

function getClient() {
  if (!client) {
    const httpLink = new HttpLink({
      uri: process.env.API_GATEWAY_URL,
    });

    client = new ApolloClient<NormalizedCacheObject>({
      cache: new InMemoryCache(),
      link: httpLink,
    });
  }

  return client;
}

function resetClient() {
  client = null;
}

export default getClient;
export { resetClient };
